import { Component, type ReactNode } from "react";
import { Button } from "@/ui/button.js";

interface Props { children: ReactNode }
interface State { crashed: boolean }

/** A crash mid-cook must not lose the session: state lives in Dexie + the
 *  server, and reload lands back on the same /cook/:sessionId URL. */
export class CookErrorBoundary extends Component<Props, State> {
  override state: State = { crashed: false };
  static getDerivedStateFromError(): State { return { crashed: true }; }
  override componentDidCatch(error: unknown): void { console.error("cooking-mode crash", error); }
  override render(): ReactNode {
    if (!this.state.crashed) return this.props.children;
    return (
      <div className="min-h-dvh flex flex-col items-center justify-center gap-4 bg-zinc-950 text-zinc-50 p-6 text-center">
        <h1 className="text-lg font-medium">Something broke — your session is safe</h1>
        <p className="text-sm text-zinc-400">Reload to pick up where you left off.</p>
        <Button onClick={() => { window.location.reload(); }}>Reload</Button>
      </div>
    );
  }
}
